module.exports = __webpack_public_path__ + "img/sn.010dc497.svg";